import * as z from "zod";

export const canSetCheckoutExperienceActive = {
  name: "canSetCheckoutExperienceActive" as const,
  input: z.null(),
  output: z.boolean(),
};
